// Sidebar menu structure
export const SidebarMenu = [
  {
    menu: "Dashboard",
    path: "/",
  },
  {
    menu: "Map View",
    path: "/map-view",
  },
  {
    menu: "Admin",
    path: "/admin",
    role: "super-admin",
  },
  {
    menu: "Chat",
    path: "/chat",
    role: "admin",
  },
  {
    menu: "Teacher",
    path: "/teacher",
  },
  {
    menu: "Parent",
    path: "/parent",
  },
  {
    menu: "Student",
    path: "/student",
  },
  {
    menu: "Tuition",
    subMenu: [
      {
        menu: "Tuition Classes",
        path: "/tuition-classes",
      },
      {
        menu: "Tuition Requests",
        path: "/tuition-requests",
      },
      {
        menu: "Tuition Periods",
        path: "/tuition-periods",
      },
      {
        menu: "Tuition Job Posts",
        path: "/tuition-job-posts",
      },
      {
        menu: "Slot Increase Requests",
        path: "/slot-increase-requests",
      },
    ],
  },
  {
    menu: "Coupon",
    path: "/coupon",
    role: "super-admin",
  },
  {
    menu: "Guru Coin",
    path: "/guru-coin",
    role: "super-admin",
  },
  {
    menu: "Purchased Package",
    path: "/purchased-package",
  },

  {
    menu: "Teacher Shadow wallet",
    path: "/teachers-shadow-wallet",
  },
  {
    menu: "Transactions",
    subMenu: [
      {
        menu: "Guru Coin Transaction",
        path: "/guru-coin-transaction",
      },
      {
        menu: "Payments",
        path: "/payments",
      },
      {
        menu: "Payouts",
        path: "/payouts",
      },
      {
        menu: "Group Class Payments",
        path: "/group-class-payments",
      },
      {
        menu: "Frachise payments",
        path: "/franchise-payments",
      },
      {
        menu: "Contact Access payments",
        path: "/contact-access-payments",
      },
    ],
  },
  {
    menu: "Group Class",
    path: "/group-class",
    // role: "super-admin",
  },
  {
    menu: "Trial class",
    path: "/trial-class",
    // role: "super-admin",
  },
  {
    menu: "Examination",
    subMenu: [
      {
        menu: "Regular",
        path: "/examination/regular",
      },
      {
        menu: "Coin Earner",
        path: "/examination/coin-earner",
      },
      {
        menu: "Puzzle",
        path: "/examination/puzzle",
      },
      {
        menu: "Questions",
        path: "/examination/questions",
      },
      {
        menu: "Mandatory Requests",
        path: "/examination/mandatory/requests",
      },
      {
        menu: "Mandatory Papers",
        path: "/examination/mandatory/papers",
      },
    ]
  },
  {
    menu: "Access request",
    path: "/access-details",
    // role: "super-admin",
  },
  {
    menu: "Info Settings",
    path: "/info-settings",
    role: "super-admin",
  },
  {
    menu: "Tier Settings",
    path: "/tier-settings",
  },
  {
    menu: "Page Content",
    role: "super-admin",
    subMenu: [
      {
        menu: "About Us",
        path: "/about-us",
      },
      {
        menu: "Terms And Conditions",
        subMenu: [
          {
            menu: "For Teachers",
            path: "/terms-conditions/teachers",
          },
          {
            menu: "For Parents",
            path: "/terms-conditions/parents",
          },
        ],
      },

      {
        menu: "Privacy Policy",
        path: "/privacy-policy",
      },
      {
        menu: "Refund Policy",
        path: "/refund-policy",
      },
      {
        menu: "Agreement Records",
        path: "/agreement-records",
      },
    ],
  },
  {
    menu: "Banner settings",
    path: "/banner",
    role: "super-admin",
  },
  {
    menu: "Training video",
    path: "/train-video",
    role: "super-admin",
  },
  {
    menu: "Admin pass",
    path: "/admin-pass",
  },
  {
    menu: "Push Notification",
    path: "/push-notification",
  }

  // {
  //   menu: "Teacher",
  //   subMenu: [
  //     {
  //       menu: "List",
  //       path: "/teacher",
  //     },
  //     {
  //       menu: "Intro Question",
  //       path: "/teacher/intro-questions",
  //     },
  //     {
  //       menu: "Subject Certification",
  //       path: "/teacher/subject-certification",
  //     },
  //   ],
  // },
  // {
  //   menu: "Subjects",
  //   subMenu: [
  //     {
  //       menu: "List",
  //       path: "/subjects/list",
  //     },
  //     {
  //       menu: "Teacher Certification Questions",
  //       path: "/subjects/teacher-certification-questions",
  //     },
  //     {
  //       menu: "Subject Certification",
  //       path: "/subjects/subject-certification",
  //     },
  //   ],
  // },
];
